
    <template>
      <section class="doc-article monkey-view-doc">
        <h1>Input 输入框</h1>
<p>表单组件。支持input、number、password、textarea类型。</p>
<h2 id="dai-ma-shi-li" class="anchor-title">代码示例 <a class="header-anchor" href="#dai-ma-shi-li">#</a></h2>
<code-wrap id="JCYF">
                <template slot="description"><p>可以使用v-model实现双向数据绑定。默认宽度100%。</p>
</template>
                <template slot="title">基础用法 <a href="#JCYF" data-title="基础用法">#</a></template>
                <template slot="source"><monkey-view-demo0 /></template>
                <template slot="highlight">
<div v-highlight><pre v-pre><code class="html">&lt;template&gt;
    &lt;Input placeholder=&quot;placeholder&quot; v-model=&quot;valueBase&quot; style=&quot;width: 300px&quot;&gt;&lt;/Input&gt;
&lt;/template&gt;
&lt;script&gt;
    export default {
      data(){
        return {
          valueBase: '',
        }
      }
    }
&lt;/script&gt;

</code></pre></div></template></code-wrap>
<code-wrap id="JY">
                <template slot="description"><p>设置 <code>disabled</code>属性禁用输入框。</p>
</template>
                <template slot="title">禁用 <a href="#JY" data-title="禁用">#</a></template>
                <template slot="source"><monkey-view-demo1 /></template>
                <template slot="highlight">
<div v-highlight><pre v-pre><code class="html">&lt;template&gt;
    &lt;Row :gutter=&quot;16&quot;&gt;
        &lt;Col&gt;
            &lt;h4&gt;input&lt;/h4&gt;
            &lt;Input disabled placeholder=&quot;placeholder&quot; v-model=&quot;valueDisabled&quot;&gt;&lt;/Input&gt;
        &lt;/Col&gt;
        &lt;Col&gt;
            &lt;h4&gt;number&lt;/h4&gt;
            &lt;Input type=&quot;number&quot; disabled placeholder=&quot;placeholder&quot; v-model=&quot;valueDisabled&quot;&gt;&lt;/Input&gt;
        &lt;/Col&gt;
        &lt;Col&gt;
            &lt;h4&gt;search&lt;/h4&gt;
            &lt;Input type=&quot;search&quot; disabled placeholder=&quot;placeholder&quot; v-model=&quot;valueDisabled&quot;&gt;&lt;/Input&gt;
        &lt;/Col&gt;
        &lt;Col&gt;
            &lt;h4&gt;password&lt;/h4&gt;
            &lt;Input type=&quot;password&quot; disabled placeholder=&quot;placeholder&quot; v-model=&quot;valueDisabled&quot;&gt;&lt;/Input&gt;
        &lt;/Col&gt;
    &lt;/Row&gt;
&lt;/template&gt;
&lt;script&gt;
    export default {
      data(){
        return {
          valueDisabled: '',
        }
      }
    }
&lt;/script&gt;

</code></pre></div></template></code-wrap>
<code-wrap id="CC">
                <template slot="description"><p>支持三种尺寸，设置 <code>size</code>为 <code>mini</code> <code>small</code> <code>large</code>实现迷你尺寸、小尺寸和大尺寸，不设置为默认尺寸。</p>
</template>
                <template slot="title">尺寸 <a href="#CC" data-title="尺寸">#</a></template>
                <template slot="source"><monkey-view-demo2 /></template>
                <template slot="highlight">
<div v-highlight><pre v-pre><code class="html">&lt;template&gt;
    &lt;Row :gutter=&quot;10&quot;&gt;
        &lt;Col&gt;
            &lt;Input size=&quot;mini&quot; placeholder=&quot;mini placeholder&quot; v-model=&quot;valueSizeMini&quot;&gt;&lt;/Input&gt;
        &lt;/Col&gt;
        &lt;Col&gt;
            &lt;Input size=&quot;small&quot; placeholder=&quot;small placeholder&quot; v-model=&quot;valueSizeSmall&quot;&gt;&lt;/Input&gt;
        &lt;/Col&gt;
        &lt;Col&gt;
            &lt;Input placeholder=&quot;default placeholder&quot; v-model=&quot;valueSizeDefault&quot;&gt;&lt;/Input&gt;
        &lt;/Col&gt;
        &lt;Col&gt;
            &lt;Input size=&quot;large&quot; placeholder=&quot;large placeholder&quot; v-model=&quot;valueSizeLarge&quot;&gt;&lt;/Input&gt;
        &lt;/Col&gt;
    &lt;/Row&gt;
&lt;/template&gt;
&lt;script&gt;
    export default {
      data(){
        return {
          valueSizeMini: '',
          valueSizeSmall: '',
          valueSizeDefault: '',
          valueSizeLarge: '',
        }
      }
    }
&lt;/script&gt;

</code></pre></div></template></code-wrap>
<code-wrap id="KQK">
                <template slot="description"><p>设置 <code>clearable</code>属性实现可清空的输入框。显示清除按钮。</p>
</template>
                <template slot="title">可清空 <a href="#KQK" data-title="可清空">#</a></template>
                <template slot="source"><monkey-view-demo3 /></template>
                <template slot="highlight">
<div v-highlight><pre v-pre><code class="html">&lt;template&gt;
    &lt;Input placeholder=&quot;placeholder&quot; clearable v-model=&quot;valueClearable&quot; style=&quot;width: 300px&quot;&gt;&lt;/Input&gt;
&lt;/template&gt;
&lt;script&gt;
    export default {
      data(){
        return {
          valueClearable: '',
        }
      }
    }
&lt;/script&gt;

</code></pre></div></template></code-wrap>
<code-wrap id="QZHHZTB">
                <template slot="description"><p>设置 <code>prefix</code>和 <code>suffix</code>属性及同名的 <code>slot</code>实现前缀和后缀图标。</p>
</template>
                <template slot="title">前缀和后缀图标 <a href="#QZHHZTB" data-title="前缀和后缀图标">#</a></template>
                <template slot="source"><monkey-view-demo4 /></template>
                <template slot="highlight">
<div v-highlight><pre v-pre><code class="html">&lt;template&gt;
    &lt;h4&gt;属性方式&lt;/h4&gt;
    &lt;Input placeholder=&quot;placeholder&quot; v-model=&quot;valuePrefix&quot; prefix=&quot;user-fill&quot; style=&quot;width: 300px&quot;&gt;&lt;/Input&gt;
    &lt;br&gt;
    &lt;Input placeholder=&quot;placeholder&quot; v-model=&quot;valueSuffix&quot; suffix=&quot;search&quot; style=&quot;width: 300px&quot;&gt;&lt;/Input&gt;

    &lt;h4&gt;slot方式&lt;/h4&gt;
    &lt;Input placeholder=&quot;placeholder&quot; v-model=&quot;valuePrefixSlot&quot; style=&quot;width: 300px&quot;&gt;
        &lt;Icon slot=&quot;prefix&quot; type=&quot;user-fill&quot;&gt;&lt;/Icon&gt;
    &lt;/Input&gt;
    &lt;br&gt;
    &lt;Input placeholder=&quot;placeholder&quot; v-model=&quot;valueSuffixSlot&quot; style=&quot;width: 300px&quot;&gt;
        &lt;Icon slot=&quot;suffix&quot; type=&quot;search&quot;&gt;&lt;/Icon&gt;
    &lt;/Input&gt;
&lt;/template&gt;
&lt;script&gt;
    export default {
      data(){
        return {
          valuePrefix: '',
          valueSuffix: '',
          valuePrefixSlot: '',
          valueSuffixSlot: '',
        }
      }
    }
&lt;/script&gt;

</code></pre></div></template></code-wrap>
<code-wrap id="QZHHZBQ">
                <template slot="description"><p>设置 <code>prefix</code>和 <code>suffix</code>属性及同名的 <code>slot</code>实现前缀和后缀图标。</p>
</template>
                <template slot="title">前置和后置标签 <a href="#QZHHZBQ" data-title="前置和后置标签">#</a></template>
                <template slot="source"><monkey-view-demo5 /></template>
                <template slot="highlight">
<div v-highlight><pre v-pre><code class="html">&lt;template&gt;
    &lt;Input placeholder=&quot;placeholder&quot; v-model=&quot;valuePrepend&quot;&gt;
        &lt;span slot=&quot;prepend&quot;&gt;http://&lt;/span&gt;
        &lt;span slot=&quot;append&quot;&gt;.com&lt;/span&gt;
    &lt;/Input&gt;
    &lt;br&gt;
    &lt;Input placeholder=&quot;placeholder&quot; v-model=&quot;valueAppend&quot;&gt;
        &lt;Select slot=&quot;prepend&quot; style=&quot;width: 70px;&quot; v-model=&quot;inputPrependSelect&quot; :option=&quot;inputPrependSelectOptions&quot; :dropdownMatchSelectWidth=&quot;false&quot;&gt;&lt;/Select&gt;
        &lt;Select slot=&quot;append&quot; style=&quot;width: 70px;&quot; v-model=&quot;inputAppendSelect&quot; :option=&quot;inputAppendSelectOptions&quot; :dropdownMatchSelectWidth=&quot;false&quot;&gt;&lt;/Select&gt;
    &lt;/Input&gt;
    &lt;br&gt;
    &lt;Input placeholder=&quot;placeholder&quot; v-model=&quot;valuePrepend&quot;&gt;
        &lt;Icon slot=&quot;append&quot; type=&quot;setting&quot;&gt;&lt;/Icon&gt;
    &lt;/Input&gt;
&lt;/template&gt;
&lt;script&gt;
    export default {
      data(){
        return {
          valuePrepend: '',
          valueAppend: '',
          inputPrependSelect: '0',
          inputPrependSelectOptions: [
            {
              label: 'http://',
              value: '0',
            },
            {
              label: 'https://',
              value: '1',
            }
          ],
          inputAppendSelect: '0',
          inputAppendSelectOptions: [
            {
              label: '.com',
              value: '0',
            },
            {
              label: '.cn',
              value: '1',
            },
            {
              label: '.net',
              value: '2',
            },
            {
              label: '.org',
              value: '3',
            }
          ],
        }
      }
    }
&lt;/script&gt;

</code></pre></div></template></code-wrap>
<code-wrap id="SSK">
                <template slot="description"><p>设置 <code>type='search'</code>开启带有搜索按钮的输入框。</p>
</template>
                <template slot="title">搜索框 <a href="#SSK" data-title="搜索框">#</a></template>
                <template slot="source"><monkey-view-demo6 /></template>
                <template slot="highlight">
<div v-highlight><pre v-pre><code class="html">&lt;template&gt;
    &lt;Input type=&quot;search&quot; placeholder=&quot;placeholder&quot; v-model=&quot;valueSearch&quot;&gt;&lt;/Input&gt;
    &lt;br&gt;
    &lt;Input type=&quot;search&quot; placeholder=&quot;placeholder&quot; v-model=&quot;valueSearch1&quot; suffixButton&gt;&lt;/Input&gt;
    &lt;br&gt;
    &lt;Input type=&quot;search&quot; placeholder=&quot;placeholder&quot; v-model=&quot;valueSearch2&quot; suffixButton=&quot;Search&quot;&gt;&lt;/Input&gt;
&lt;/template&gt;
&lt;script&gt;
    export default {
      data(){
        return {
           valueSearch: '',
           valueSearch1: '',
           valueSearch2: '',
        }
      }
    }
&lt;/script&gt;

</code></pre></div></template></code-wrap>
<code-wrap id="MMK">
                <template slot="description"><p>设置 <code>type='password'</code>开启密码输入框。可以自定义密码框的后缀图标或者不显示图标</p>
</template>
                <template slot="title">密码框 <a href="#MMK" data-title="密码框">#</a></template>
                <template slot="source"><monkey-view-demo7 /></template>
                <template slot="highlight">
<div v-highlight><pre v-pre><code class="html">&lt;template&gt;
    &lt;Input type=&quot;password&quot; placeholder=&quot;placeholder&quot; v-model=&quot;valuePassword&quot;&gt;&lt;/Input&gt;
    &lt;br&gt;
    &lt;Input type=&quot;password&quot; placeholder=&quot;placeholder&quot; v-model=&quot;valuePassword1&quot; :showPasswordIcon=&quot;false&quot;&gt;&lt;/Input&gt;
    &lt;br&gt;
    &lt;Input type=&quot;password&quot; placeholder=&quot;placeholder&quot; v-model=&quot;valuePassword2&quot;&gt;
        &lt;Icon slot=&quot;suffix&quot; type=&quot;password&quot;&gt;&lt;/Icon&gt;
    &lt;/Input&gt;
&lt;/template&gt;
&lt;script&gt;
    export default {
      data(){
        return {
           valuePassword: '',
           valuePassword1: '',
           valuePassword2: '',
        }
      }
    }
&lt;/script&gt;

</code></pre></div></template></code-wrap>
<code-wrap id="SZSRK">
                <template slot="description"><p>设置 <code>type='number'</code>开启数字输入框。数字输入框的默认 <code>step=1</code>。可以自定义 <code>step</code>大小，也可以设置 <code>step=false</code>不显示操作。</p>
</template>
                <template slot="title">数字输入框 <a href="#SZSRK" data-title="数字输入框">#</a></template>
                <template slot="source"><monkey-view-demo8 /></template>
                <template slot="highlight">
<div v-highlight><pre v-pre><code class="html">&lt;template&gt;
    &lt;Input type=&quot;number&quot; placeholder=&quot;placeholder&quot; v-model=&quot;valueNumber&quot;&gt;&lt;/Input&gt;
    &lt;h4&gt;step=2&lt;/h4&gt;
    &lt;Input type=&quot;number&quot; placeholder=&quot;placeholder&quot; v-model=&quot;valueNumber1&quot; :step=&quot;2&quot;&gt;&lt;/Input&gt;
    &lt;h4&gt;step=false&lt;/h4&gt;
    &lt;Input type=&quot;number&quot; placeholder=&quot;placeholder&quot; v-model=&quot;valueNumber2&quot; :step=&quot;false&quot;&gt;&lt;/Input&gt;
    &lt;h4&gt;stepType='right'&lt;/h4&gt;
    &lt;Input type=&quot;number&quot; placeholder=&quot;placeholder&quot; v-model=&quot;valueNumber3&quot; stepType=&quot;right&quot;&gt;&lt;/Input&gt;
    &lt;h4&gt;限制最大最小值及小数位：min=0,max=100,precision=2&lt;/h4&gt;
    &lt;Input type=&quot;number&quot; placeholder=&quot;placeholder&quot; v-model=&quot;valueNumber4&quot; :min=&quot;0&quot; :max=&quot;100&quot; :precision=&quot;2&quot;&gt;&lt;/Input&gt;
&lt;/template&gt;
&lt;script&gt;
    export default {
      data(){
        return {
           valueNumber: '',
           valueNumber1: '',
           valueNumber2: '',
           valueNumber3: '',
           valueNumber4: '',
        }
      }
    }
&lt;/script&gt;

</code></pre></div></template></code-wrap>
<code-wrap id="WBY">
                <template slot="description"><p>设置 <code>type='textarea'</code>开启文本域模式。设置 <code>autosize</code>属性可自适应高度，该属性设置为对象可设置最小行数和最大行数。</p>
</template>
                <template slot="title">文本域 <a href="#WBY" data-title="文本域">#</a></template>
                <template slot="source"><monkey-view-demo9 /></template>
                <template slot="highlight">
<div v-highlight><pre v-pre><code class="html">&lt;template&gt;
    &lt;Input type=&quot;textarea&quot; placeholder=&quot;placeholder&quot; v-model=&quot;valueTextarea&quot;&gt;&lt;/Input&gt;
    &lt;h4&gt;自适应高度&lt;/h4&gt;
    &lt;Input type=&quot;textarea&quot; placeholder=&quot;placeholder&quot; v-model=&quot;valueTextarea1&quot; autosize&gt;&lt;/Input&gt;
    &lt;Input type=&quot;textarea&quot; placeholder=&quot;placeholder&quot; v-model=&quot;valueTextarea2&quot; :autosize=&quot;{minRows: 3, maxRows: 6}&quot;&gt;&lt;/Input&gt;
    &lt;h4&gt;设置文本域大小&lt;/h4&gt;
    &lt;Input type=&quot;textarea&quot; placeholder=&quot;placeholder&quot; v-model=&quot;valueTextarea3&quot; :rows=&quot;5&quot;&gt;&lt;/Input&gt;
    &lt;h4&gt;限制输入长度并显示输入长度：maxLength=20,showLimitLabel&lt;/h4&gt;
    &lt;Input type=&quot;textarea&quot; placeholder=&quot;placeholder&quot; v-model=&quot;valueTextarea4&quot; :maxLength=&quot;20&quot; showLimitLabel&gt;&lt;/Input&gt;
&lt;/template&gt;
&lt;script&gt;
    export default {
      data(){
        return {
           valueTextarea: '',
           valueTextarea1: '',
           valueTextarea2: '',
           valueTextarea3: '',
           valueTextarea4: '',
        }
      }
    }
&lt;/script&gt;

</code></pre></div></template></code-wrap>
<h2 id="api" class="anchor-title">API <a class="header-anchor" href="#api">#</a></h2>
<h3 id="input-props" class="anchor-title">Input props <a class="header-anchor" href="#input-props">#</a></h3>
<table class="doc-table"><thead>
<tr>
<th>属性</th>
<th>类型</th>
<th>说明</th>
<th>默认值</th>
</tr>
</thead>
<tbody>
<tr>
<td>type</td>
<td>String</td>
<td>设置文本框的类型，可选值 <code>input</code> <code>number</code> <code>search</code> <code>password</code> <code>textarea</code></td>
<td>input</td>
</tr>
<tr>
<td>name</td>
<td>String</td>
<td>原生name属性</td>
<td>-</td>
</tr>
<tr>
<td>value</td>
<td>String, Number</td>
<td>绑定的值，可以使用v-model进行双向绑定</td>
<td>-</td>
</tr>
<tr>
<td>disabled</td>
<td>Boolean</td>
<td>禁用</td>
<td>-</td>
</tr>
<tr>
<td>readonly</td>
<td>Boolean</td>
<td>只读属性</td>
<td>-</td>
</tr>
<tr>
<td>placeholder</td>
<td>String</td>
<td>占位文本</td>
<td>-</td>
</tr>
<tr>
<td>size</td>
<td>String</td>
<td>尺寸，可选值 <code>mini</code> <code>small</code> <code>large</code>或者不设置</td>
<td>-</td>
</tr>
<tr>
<td>step</td>
<td>Boolean, Number</td>
<td>type为number时，每次改变的步数，可以是小数。false时不显示控制按钮， true时显示控制按钮，默认显示左右按钮</td>
<td>1</td>
</tr>
<tr>
<td>step-type</td>
<td>String</td>
<td>type为<code>number</code>时，控制按钮显示的位置。可选值<code>right</code></td>
<td>1</td>
</tr>
<tr>
<td>min</td>
<td>Number</td>
<td>最小值。type类型为<code>number</code>时有用，设置可输入的最小值</td>
<td>-</td>
</tr>
<tr>
<td>max</td>
<td>Number</td>
<td>最大值。type类型为<code>number</code>时有用，设置可输入的最大值</td>
<td>-</td>
</tr>
<tr>
<td>precision</td>
<td>Number</td>
<td>保留小数点位数。type类型为<code>number</code>时有用</td>
<td>-</td>
</tr>
<tr>
<td>max-length</td>
<td>Number</td>
<td>可输入的最大字符长度。<code>input</code>和<code>textarea</code>时有效</td>
<td>-</td>
</tr>
<tr>
<td>show-limit-label</td>
<td>Boolean</td>
<td>是否显示限制。为true时会在输入框或者textarea尾部显示当前字符长度和限制长度<code>man-length</code>。该值需要和<code>man-length</code>配合使用。</td>
<td>-</td>
</tr>
<tr>
<td>autosize</td>
<td>Boolean, Object</td>
<td>type为<code>textarea</code>时有效。自适应内容高度，可设置对象，如<code>{minRows: 2, maxRows: 6}</code></td>
<td>-</td>
</tr>
<tr>
<td>rows</td>
<td>Number</td>
<td>type为<code>textarea</code>时有效。默认行数，超出时显示滚动条</td>
<td>-</td>
</tr>
<tr>
<td>show-password-icon</td>
<td>Boolean, Object</td>
<td>type为<code>password</code>时尾部显示控制字符显示的icon图标。false时不显示。可设置对象，设置icon，如：<code>{close: 'close', open: 'square-plus'}</code></td>
<td>true</td>
</tr>
<tr>
<td>suffix</td>
<td>String</td>
<td>输入框尾部图标。<code>textarea</code>时无效。type为<code>search</code>时默认显示搜索图标</td>
<td>-</td>
</tr>
<tr>
<td>prefix</td>
<td>Boolean, String</td>
<td>输入框头部图标。<code>textarea</code>时无效</td>
<td>-</td>
</tr>
<tr>
<td>suffix-button</td>
<td>String</td>
<td>type为<code>search</code>时有效。定义搜索按钮，true时显示纯图标的按钮，string时可定义按钮的文字</td>
<td>false</td>
</tr>
<tr>
<td>clearable</td>
<td>Boolean</td>
<td>显示清除图标。type为<code>textarea</code>时无效</td>
<td>false</td>
</tr>
<tr>
<td>input-style</td>
<td>Object</td>
<td>输入框的样式，type为<code>textarea</code>时无效</td>
<td>false</td>
</tr>
</tbody>
</table>
<h3 id="input-event" class="anchor-title">Input event <a class="header-anchor" href="#input-event">#</a></h3>
<table class="doc-table"><thead>
<tr>
<th>事件名</th>
<th>说明</th>
<th>返回值</th>
</tr>
</thead>
<tbody>
<tr>
<td>change</td>
<td>数据改变时触发</td>
<td>-</td>
</tr>
<tr>
<td>blur</td>
<td>失去焦点时触发</td>
<td>-</td>
</tr>
<tr>
<td>focus</td>
<td>获取焦点时触发</td>
<td>-</td>
</tr>
<tr>
<td>enter</td>
<td>按下回车键时触发</td>
<td>-</td>
</tr>
<tr>
<td>search</td>
<td>按下搜索或回车键时触发。<code>search</code>状态下有用</td>
<td>-</td>
</tr>
<tr>
<td>clear</td>
<td>开始<code>clearable</code>时有用。点击清空按钮时触发</td>
<td>-</td>
</tr>
</tbody>
</table>
<h3 id="input-slot" class="anchor-title">Input slot <a class="header-anchor" href="#input-slot">#</a></h3>
<table class="doc-table"><thead>
<tr>
<th>名称</th>
<th>说明</th>
</tr>
</thead>
<tbody>
<tr>
<td>prepend</td>
<td>前置内容。type为<code>textarea</code>时无效</td>
</tr>
<tr>
<td>prefix</td>
<td>输入框头部内容。设置此项内容后内置的<code>prefix</code>无效。type为<code>textarea</code>时无效</td>
</tr>
<tr>
<td>suffix</td>
<td>输入框尾部内容。设置此项内容后会导致内置<code>suffix</code>的无效。type为<code>textarea</code>时无效</td>
</tr>
<tr>
<td>append</td>
<td>后置内容。设置此项内容后<code>suffix-button</code>无效。type为<code>textarea</code>时无效</td>
</tr>
</tbody>
</table>
<h3 id="input-methods" class="anchor-title">Input methods <a class="header-anchor" href="#input-methods">#</a></h3>
<table class="doc-table"><thead>
<tr>
<th>名称</th>
<th>说明</th>
<th>参数</th>
</tr>
</thead>
<tbody>
<tr>
<td>focus</td>
<td>主动使input获取焦点</td>
<td>-</td>
</tr>
<tr>
<td>blur</td>
<td>主动使input失去焦点</td>
<td>-</td>
</tr>
</tbody>
</table>

      </section>
    </template>
    <script>
      export default {
        name: 'component-doc',
        components: {
          "monkey-view-demo0": (function() {
    
    var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[[_c('Input',{staticStyle:{"width":"300px"},attrs:{"placeholder":"placeholder"},model:{value:(_vm.valueBase),callback:function ($$v) {_vm.valueBase=$$v},expression:"valueBase"}})]],2)}
var staticRenderFns = []

  
    const democomponentExport = {
      data(){
        return {
          valueBase: '',
        }
      }
    }
    return {
      render,
      staticRenderFns,
      ...democomponentExport
    }
  })(),"monkey-view-demo1": (function() {
    
    var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[[_c('Row',{attrs:{"gutter":16}},[_c('Col',[_c('h4',[_vm._v("input")]),_vm._v(" "),_c('Input',{attrs:{"disabled":"","placeholder":"placeholder"},model:{value:(_vm.valueDisabled),callback:function ($$v) {_vm.valueDisabled=$$v},expression:"valueDisabled"}})],1),_vm._v(" "),_c('Col',[_c('h4',[_vm._v("number")]),_vm._v(" "),_c('Input',{attrs:{"type":"number","disabled":"","placeholder":"placeholder"},model:{value:(_vm.valueDisabled),callback:function ($$v) {_vm.valueDisabled=$$v},expression:"valueDisabled"}})],1),_vm._v(" "),_c('Col',[_c('h4',[_vm._v("search")]),_vm._v(" "),_c('Input',{attrs:{"type":"search","disabled":"","placeholder":"placeholder"},model:{value:(_vm.valueDisabled),callback:function ($$v) {_vm.valueDisabled=$$v},expression:"valueDisabled"}})],1),_vm._v(" "),_c('Col',[_c('h4',[_vm._v("password")]),_vm._v(" "),_c('Input',{attrs:{"type":"password","disabled":"","placeholder":"placeholder"},model:{value:(_vm.valueDisabled),callback:function ($$v) {_vm.valueDisabled=$$v},expression:"valueDisabled"}})],1)],1)]],2)}
var staticRenderFns = []

  
    const democomponentExport = {
      data(){
        return {
          valueDisabled: '',
        }
      }
    }
    return {
      render,
      staticRenderFns,
      ...democomponentExport
    }
  })(),"monkey-view-demo2": (function() {
    
    var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[[_c('Row',{attrs:{"gutter":10}},[_c('Col',[_c('Input',{attrs:{"size":"mini","placeholder":"mini placeholder"},model:{value:(_vm.valueSizeMini),callback:function ($$v) {_vm.valueSizeMini=$$v},expression:"valueSizeMini"}})],1),_vm._v(" "),_c('Col',[_c('Input',{attrs:{"size":"small","placeholder":"small placeholder"},model:{value:(_vm.valueSizeSmall),callback:function ($$v) {_vm.valueSizeSmall=$$v},expression:"valueSizeSmall"}})],1),_vm._v(" "),_c('Col',[_c('Input',{attrs:{"placeholder":"default placeholder"},model:{value:(_vm.valueSizeDefault),callback:function ($$v) {_vm.valueSizeDefault=$$v},expression:"valueSizeDefault"}})],1),_vm._v(" "),_c('Col',[_c('Input',{attrs:{"size":"large","placeholder":"large placeholder"},model:{value:(_vm.valueSizeLarge),callback:function ($$v) {_vm.valueSizeLarge=$$v},expression:"valueSizeLarge"}})],1)],1)]],2)}
var staticRenderFns = []

  
    const democomponentExport = {
      data(){
        return {
          valueSizeMini: '',
          valueSizeSmall: '',
          valueSizeDefault: '',
          valueSizeLarge: '',
        }
      }
    }
    return {
      render,
      staticRenderFns,
      ...democomponentExport
    }
  })(),"monkey-view-demo3": (function() {
    
    var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[[_c('Input',{staticStyle:{"width":"300px"},attrs:{"placeholder":"placeholder","clearable":""},model:{value:(_vm.valueClearable),callback:function ($$v) {_vm.valueClearable=$$v},expression:"valueClearable"}})]],2)}
var staticRenderFns = []

  
    const democomponentExport = {
      data(){
        return {
          valueClearable: '',
        }
      }
    }
    return {
      render,
      staticRenderFns,
      ...democomponentExport
    }
  })(),"monkey-view-demo4": (function() {
    
    var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[[_c('h4',[_vm._v("属性方式")]),_vm._v(" "),_c('Input',{staticStyle:{"width":"300px"},attrs:{"placeholder":"placeholder","prefix":"user-fill"},model:{value:(_vm.valuePrefix),callback:function ($$v) {_vm.valuePrefix=$$v},expression:"valuePrefix"}}),_vm._v(" "),_c('br'),_vm._v(" "),_c('Input',{staticStyle:{"width":"300px"},attrs:{"placeholder":"placeholder","suffix":"search"},model:{value:(_vm.valueSuffix),callback:function ($$v) {_vm.valueSuffix=$$v},expression:"valueSuffix"}}),_vm._v(" "),_c('h4',[_vm._v("slot方式")]),_vm._v(" "),_c('Input',{staticStyle:{"width":"300px"},attrs:{"placeholder":"placeholder"},model:{value:(_vm.valuePrefixSlot),callback:function ($$v) {_vm.valuePrefixSlot=$$v},expression:"valuePrefixSlot"}},[_c('Icon',{attrs:{"slot":"prefix","type":"user-fill"},slot:"prefix"})],1),_vm._v(" "),_c('br'),_vm._v(" "),_c('Input',{staticStyle:{"width":"300px"},attrs:{"placeholder":"placeholder"},model:{value:(_vm.valueSuffixSlot),callback:function ($$v) {_vm.valueSuffixSlot=$$v},expression:"valueSuffixSlot"}},[_c('Icon',{attrs:{"slot":"suffix","type":"search"},slot:"suffix"})],1)]],2)}
var staticRenderFns = []

  
    const democomponentExport = {
      data(){
        return {
          valuePrefix: '',
          valueSuffix: '',
          valuePrefixSlot: '',
          valueSuffixSlot: '',
        }
      }
    }
    return {
      render,
      staticRenderFns,
      ...democomponentExport
    }
  })(),"monkey-view-demo5": (function() {
    
    var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[[_c('Input',{attrs:{"placeholder":"placeholder"},model:{value:(_vm.valuePrepend),callback:function ($$v) {_vm.valuePrepend=$$v},expression:"valuePrepend"}},[_c('span',{attrs:{"slot":"prepend"},slot:"prepend"},[_vm._v("http://")]),_vm._v(" "),_c('span',{attrs:{"slot":"append"},slot:"append"},[_vm._v(".com")])]),_vm._v(" "),_c('br'),_vm._v(" "),_c('Input',{attrs:{"placeholder":"placeholder"},model:{value:(_vm.valueAppend),callback:function ($$v) {_vm.valueAppend=$$v},expression:"valueAppend"}},[_c('Select',{staticStyle:{"width":"70px"},attrs:{"slot":"prepend","option":_vm.inputPrependSelectOptions,"dropdownMatchSelectWidth":false},slot:"prepend",model:{value:(_vm.inputPrependSelect),callback:function ($$v) {_vm.inputPrependSelect=$$v},expression:"inputPrependSelect"}}),_vm._v(" "),_c('Select',{staticStyle:{"width":"70px"},attrs:{"slot":"append","option":_vm.inputAppendSelectOptions,"dropdownMatchSelectWidth":false},slot:"append",model:{value:(_vm.inputAppendSelect),callback:function ($$v) {_vm.inputAppendSelect=$$v},expression:"inputAppendSelect"}})],1),_vm._v(" "),_c('br'),_vm._v(" "),_c('Input',{attrs:{"placeholder":"placeholder"},model:{value:(_vm.valuePrepend),callback:function ($$v) {_vm.valuePrepend=$$v},expression:"valuePrepend"}},[_c('Icon',{attrs:{"slot":"append","type":"setting"},slot:"append"})],1)]],2)}
var staticRenderFns = []

  
    const democomponentExport = {
      data(){
        return {
          valuePrepend: '',
          valueAppend: '',
          inputPrependSelect: '0',
          inputPrependSelectOptions: [
            {
              label: 'http://',
              value: '0',
            },
            {
              label: 'https://',
              value: '1',
            }
          ],
          inputAppendSelect: '0',
          inputAppendSelectOptions: [
            {
              label: '.com',
              value: '0',
            },
            {
              label: '.cn',
              value: '1',
            },
            {
              label: '.net',
              value: '2',
            },
            {
              label: '.org',
              value: '3',
            }
          ],
        }
      }
    }
    return {
      render,
      staticRenderFns,
      ...democomponentExport
    }
  })(),"monkey-view-demo6": (function() {
    
    var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[[_c('Input',{attrs:{"type":"search","placeholder":"placeholder"},model:{value:(_vm.valueSearch),callback:function ($$v) {_vm.valueSearch=$$v},expression:"valueSearch"}}),_vm._v(" "),_c('br'),_vm._v(" "),_c('Input',{attrs:{"type":"search","placeholder":"placeholder","suffixButton":""},model:{value:(_vm.valueSearch1),callback:function ($$v) {_vm.valueSearch1=$$v},expression:"valueSearch1"}}),_vm._v(" "),_c('br'),_vm._v(" "),_c('Input',{attrs:{"type":"search","placeholder":"placeholder","suffixButton":"Search"},model:{value:(_vm.valueSearch2),callback:function ($$v) {_vm.valueSearch2=$$v},expression:"valueSearch2"}})]],2)}
var staticRenderFns = []

  
    const democomponentExport = {
      data(){
        return {
           valueSearch: '',
           valueSearch1: '',
           valueSearch2: '',
        }
      }
    }
    return {
      render,
      staticRenderFns,
      ...democomponentExport
    }
  })(),"monkey-view-demo7": (function() {
    
    var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[[_c('Input',{attrs:{"type":"password","placeholder":"placeholder"},model:{value:(_vm.valuePassword),callback:function ($$v) {_vm.valuePassword=$$v},expression:"valuePassword"}}),_vm._v(" "),_c('br'),_vm._v(" "),_c('Input',{attrs:{"type":"password","placeholder":"placeholder","showPasswordIcon":false},model:{value:(_vm.valuePassword1),callback:function ($$v) {_vm.valuePassword1=$$v},expression:"valuePassword1"}}),_vm._v(" "),_c('br'),_vm._v(" "),_c('Input',{attrs:{"type":"password","placeholder":"placeholder"},model:{value:(_vm.valuePassword2),callback:function ($$v) {_vm.valuePassword2=$$v},expression:"valuePassword2"}},[_c('Icon',{attrs:{"slot":"suffix","type":"password"},slot:"suffix"})],1)]],2)}
var staticRenderFns = []

  
    const democomponentExport = {
      data(){
        return {
           valuePassword: '',
           valuePassword1: '',
           valuePassword2: '',
        }
      }
    }
    return {
      render,
      staticRenderFns,
      ...democomponentExport
    }
  })(),"monkey-view-demo8": (function() {
    
    var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[[_c('Input',{attrs:{"type":"number","placeholder":"placeholder"},model:{value:(_vm.valueNumber),callback:function ($$v) {_vm.valueNumber=$$v},expression:"valueNumber"}}),_vm._v(" "),_c('h4',[_vm._v("step=2")]),_vm._v(" "),_c('Input',{attrs:{"type":"number","placeholder":"placeholder","step":2},model:{value:(_vm.valueNumber1),callback:function ($$v) {_vm.valueNumber1=$$v},expression:"valueNumber1"}}),_vm._v(" "),_c('h4',[_vm._v("step=false")]),_vm._v(" "),_c('Input',{attrs:{"type":"number","placeholder":"placeholder","step":false},model:{value:(_vm.valueNumber2),callback:function ($$v) {_vm.valueNumber2=$$v},expression:"valueNumber2"}}),_vm._v(" "),_c('h4',[_vm._v("stepType='right'")]),_vm._v(" "),_c('Input',{attrs:{"type":"number","placeholder":"placeholder","stepType":"right"},model:{value:(_vm.valueNumber3),callback:function ($$v) {_vm.valueNumber3=$$v},expression:"valueNumber3"}}),_vm._v(" "),_c('h4',[_vm._v("限制最大最小值及小数位：min=0,max=100,precision=2")]),_vm._v(" "),_c('Input',{attrs:{"type":"number","placeholder":"placeholder","min":0,"max":100,"precision":2},model:{value:(_vm.valueNumber4),callback:function ($$v) {_vm.valueNumber4=$$v},expression:"valueNumber4"}})]],2)}
var staticRenderFns = []

  
    const democomponentExport = {
      data(){
        return {
           valueNumber: '',
           valueNumber1: '',
           valueNumber2: '',
           valueNumber3: '',
           valueNumber4: '',
        }
      }
    }
    return {
      render,
      staticRenderFns,
      ...democomponentExport
    }
  })(),"monkey-view-demo9": (function() {
    
    var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[[_c('Input',{attrs:{"type":"textarea","placeholder":"placeholder"},model:{value:(_vm.valueTextarea),callback:function ($$v) {_vm.valueTextarea=$$v},expression:"valueTextarea"}}),_vm._v(" "),_c('h4',[_vm._v("自适应高度")]),_vm._v(" "),_c('Input',{attrs:{"type":"textarea","placeholder":"placeholder","autosize":""},model:{value:(_vm.valueTextarea1),callback:function ($$v) {_vm.valueTextarea1=$$v},expression:"valueTextarea1"}}),_vm._v(" "),_c('Input',{attrs:{"type":"textarea","placeholder":"placeholder","autosize":{minRows: 3, maxRows: 6}},model:{value:(_vm.valueTextarea2),callback:function ($$v) {_vm.valueTextarea2=$$v},expression:"valueTextarea2"}}),_vm._v(" "),_c('h4',[_vm._v("设置文本域大小")]),_vm._v(" "),_c('Input',{attrs:{"type":"textarea","placeholder":"placeholder","rows":5},model:{value:(_vm.valueTextarea3),callback:function ($$v) {_vm.valueTextarea3=$$v},expression:"valueTextarea3"}}),_vm._v(" "),_c('h4',[_vm._v("限制输入长度并显示输入长度：maxLength=20,showLimitLabel")]),_vm._v(" "),_c('Input',{attrs:{"type":"textarea","placeholder":"placeholder","maxLength":20,"showLimitLabel":""},model:{value:(_vm.valueTextarea4),callback:function ($$v) {_vm.valueTextarea4=$$v},expression:"valueTextarea4"}})]],2)}
var staticRenderFns = []

  
    const democomponentExport = {
      data(){
        return {
           valueTextarea: '',
           valueTextarea1: '',
           valueTextarea2: '',
           valueTextarea3: '',
           valueTextarea4: '',
        }
      }
    }
    return {
      render,
      staticRenderFns,
      ...democomponentExport
    }
  })(),
        }
      }
    </script>
  